import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { Link } from 'react-router-dom';
import SearchFilter from '../Reusable/SearchFilter';
import withTranslations from '../../utils/HighOrderComponent';
import KjsRow from './KjsRow';
import SyncIcon from '@material-ui/icons/Sync';
import Tooltip from '@material-ui/core/Tooltip';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import axios from 'axios';
import { userRoles } from '../../constants/globals';
import { checkForUserRole, fetchLocaleFromLocalStorage } from '../../utils';
import { extractAccessToken } from '../../securityUtils/tokenData';
import { CLIENT_ROOT } from '../../securityUtils/oidcConfig';
axios.defaults.timeout = 1200000;

class KjsTable extends Component {
  synchronizationKJS = () => {
    const {
        t,
        gt,
        pageNumber,
        pageSize,
        syncLoadingStart,
        syncLoadingStop,
        findAllKjsPageable,
      } = this.props || {},
      { ConfirmDialog } = t;

    const action = async () => {
      syncLoadingStart();
      const waitTime = 1200000;
      const handleError = (error) => {
        // this makes sure that the FAIL output isn't repeated in the case when there's a failure before the timeout
        if (!error.handled) {
          if (error.timedout) {
            console.log('TIMEDOUT', error.timedout);
          } else {
            console.log('FAIL!', error.message);
            error.handled = true;
            throw error;
          }
        }
      }; //'http://localhost:8080/api/kjs/sync',
      const myRequest = axios({
        url: `${CLIENT_ROOT}api/kjs/sync`,
        data: {},
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
          Authorization: extractAccessToken(),
          locale: fetchLocaleFromLocalStorage(),
        },
      })
        .then((result) => {
          console.log('SUCCESS!', JSON.stringify(result.data, null, 2));
          syncLoadingStop();
          findAllKjsPageable(pageNumber, pageSize);
        })
        .catch(handleError);

      const timer = new Promise((_, reject) =>
        setTimeout(reject, waitTime, { timedout: 'request taking a long time' })
      );

      return Promise.race([myRequest, timer]).catch(handleError);
    };

    confirmDialog(ConfirmDialog.confirmMessage, action, '', gt);
  };

  render() {
    const {
        t,
        loggedUser,
        updateKjs,
        gt,
        kjsWithMunicipalityList,
        findAllKjsMunicipalityPageable,
        pageNumber,
        pageSize,
        updateKjsWithMunicpality,
        placeList,
        municipalityList,
        kjsList,
        institutionTypeList,
        findAllPlace,
        findAllKjs,
        findAllKjsFilterPageable,
        clearPlaceList,
        clearMunicipalityList,
        clearKjsList,
        findAllMunicipalityByPlace,
      } = this.props || {},
      { HeaderColumns, titleTable, synchronization } = t || {};
    const kjsRowList = kjsWithMunicipalityList.map(
      (kjsWithMunicipality, index) => (
        <KjsRow
          index={index + 1}
          key={kjsWithMunicipality.id}
          kjsWithMunicipality={kjsWithMunicipality}
          translations={t}
          updateKjs={updateKjs}
          gt={gt}
          findAllKjsMunicipalityPageable={findAllKjsMunicipalityPageable}
          pageSize={pageSize}
          pageNumber={pageNumber}
          updateKjsWithMunicpality={updateKjsWithMunicpality}
          placeList={placeList}
          municipalityList={municipalityList}
          kjsList={kjsList}
          institutionTypeList={institutionTypeList}
          clearPlaceList={clearPlaceList}
          clearMunicipalityList={clearMunicipalityList}
          findAllPlace={findAllPlace}
          findAllKjs={findAllKjs}
          findAllKjsFilterPageable={findAllKjsFilterPageable}
          findAllMunicipalityByPlace={findAllMunicipalityByPlace}
          clearKjsList={clearKjsList}
        />
      )
    );

    const isSyncAllowed = checkForUserRole(
      loggedUser?.roles,
      userRoles.SUPER_ADMIN.value
    );
    const colStyle = isSyncAllowed ? 'col-md-4' : 'col-md-4 ml-auto';
    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-7">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
                <Col className={colStyle}>
                  <SearchFilter noSearchColums={0} />
                </Col>
                {isSyncAllowed && (
                  <Col className="col-md-1">
                    <Link onClick={() => this.synchronizationKJS()} to="#">
                      <Tooltip
                        title={synchronization}
                        placement="top"
                        arrow={true}
                      >
                        <SyncIcon
                          fontSize="large"
                          style={{ color: '#203a5d' }}
                        />
                      </Tooltip>
                    </Link>
                  </Col>
                )}
              </Row>
            </Card.Header>
            <Table responsive hover id="table">
              <thead>
                <tr className="text-center">
                  <th className="align-top" width="4%">
                    #
                  </th>
                  <th className="align-top">{HeaderColumns.name}</th>
                  <th className="align-top">{HeaderColumns.uniqueNumber}</th>
                  <th className="align-top">{HeaderColumns.pib}</th>
                  <th className="align-top" width="14%">
                    {HeaderColumns.municipality}
                  </th>
                  <th className="align-top" width="14%">
                    {HeaderColumns.updateMunicipality}
                  </th>
                  <th className="align-top" width="14%">
                    {HeaderColumns.update}
                  </th>
                </tr>
              </thead>
              <tbody>{kjsRowList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return <Fragment>{table}</Fragment>;
  }
}

export default withTranslations(KjsTable, 'KjsTable');
